module.exports = __webpack_public_path__ + "static/media/call-icon.8c7a40f1.svg";